// Typescript definitions for types relating to progress. Note that many
// of these are "duplicated" by `/templates/progress/progressTypes, which defined
// these using PropTypes for usage in Javascript React components. As we move towards
// typescript we can deprecate the PropTypes definitions and use these instead.
/**
 * See ApplicationHelper::PUZZLE_PAGE_NONE.
 */
export var PUZZLE_PAGE_NONE = -1;
export var ReviewStates = {
    completed: 'completed',
    keepWorking: 'keepWorking',
    awaitingReview: 'awaitingReview',
};
export var ViewType = {
    Participant: 'Participant',
    Instructor: 'Instructor',
};
